export default {
  styleOverrides: {
    root: {
      fontSize: "0.875rem",
      color: "rgba(0, 0, 0, 0.87)",
    },
  },
};
